import { RoutingFilterResponse } from '../../serverApi/requests/RoutingFilterTypes';
import { UserDefinedPoolModel } from '../types/PoolModel';
import { RoutingFilterItem } from '../types/RoutingFilterItem';
import { UnsavedFilter } from './RoutingFiltersConflictContext';

// Pure response→view-model mappers, extracted from BridgeRoutingFilters so the
// component is left with orchestration only. No React or server dependency here.

export function resolvePoolName(poolId: string | undefined, pools: Record<string, UserDefinedPoolModel>): string | undefined {
  if (!poolId) {
    return undefined;
  }
  const pool = pools[poolId];
  if (pool) {
    return pool.displayName;
  }
  return poolId;
}

// Shared shape mapping for a single filter. poolName is resolved by the caller
// because the two entry points differ only there: the response mapper prefers the
// server-provided poolName, while the unsaved mapper always resolves from the pool
// model. Everything else (including the projects mapping) is identical.
function toRoutingFilterItem(filter: RoutingFilterResponse, poolName: string | undefined): RoutingFilterItem {
  return {
    id: filter.id,
    domain: filter.domain,
    isBlocked: filter.blocked,
    poolId: filter.poolId,
    poolName,
    projects: (filter.projects ?? []).map(p => ({ id: p.id, displayValue: p.displayValue, deleted: p.deleted })),
  };
}

export function mapResponseToRoutingFilterItems(
  filters: ReadonlyArray<RoutingFilterResponse>,
  pools: Record<string, UserDefinedPoolModel>
): RoutingFilterItem[] {
  return filters.map(f => toRoutingFilterItem(f, f.poolName ?? resolvePoolName(f.poolId, pools)));
}

export function mapUnsavedFilterToRoutingFilterItem(
  source: UnsavedFilter,
  pools: Record<string, UserDefinedPoolModel>
): RoutingFilterItem {
  return toRoutingFilterItem(source.filter, resolvePoolName(source.filter.poolId, pools));
}
